export const formatTotalDataList = (data, dictData) => {
    if (!data.length) return [];
    data.forEach(item => {
        item.taskStatusName = dictData.TMS_TASK_STATUS[item.taskStatus] || item.taskStatus;
    });
    return data;
};